import { Callout, Flex, Spinner } from '@radix-ui/themes';
import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { useAgent } from '@getdutchie/agent-react';
import { useRegisterTools } from '@/agent-tools';
import { Header } from '@/ui/layout/header';
import { Main } from '@/ui/layout/main';
import { Footer } from '@/ui/layout/footer';
import { PickupPrompts } from '@/features/pickup-prompts/pickup-prompts';
import { Conversation } from '@/features/chat/conversation/conversation';
import { PromptInput } from '@/features/chat/prompt-input/prompt-input';

interface ShellProps {
  onClose?: () => void;
}

export function Shell({ onClose }: ShellProps) {
  const { messages, error, isConnected } = useAgent();

  useRegisterTools();

  const isInChat = messages.length > 0;

  return (
    <Flex
      direction="column"
      style={{
        height: onClose ? '100%' : '100vh',
      }}
    >
      <Header onClose={onClose} />
      <Main>
        {error ? (
          <Callout.Root color="red" mx="4" mt="3">
            <Callout.Icon>
              <ExclamationTriangleIcon />
            </Callout.Icon>
            <Callout.Text>{error}</Callout.Text>
          </Callout.Root>
        ) : !isConnected ? (
          <Flex align="center" justify="center" flexGrow="1" py="9">
            <Spinner size="3" />
          </Flex>
        ) : isInChat ? (
          <Conversation />
        ) : (
          <PickupPrompts />
        )}
      </Main>
      <Footer>
        <PromptInput disabled={!isConnected} />
      </Footer>
    </Flex>
  );
}
